<template>
  <div>
    <template v-if="count">
      <div v-for="v in list" :key="`student-update-${v.id}`" class="item-box">

        <template v-for="(updateType, key) in studentUpdateTypes">

          <template v-if="v.update_type === updateType.value">
            <div :key="`${v.id}-${key}-icon`" class="icon-box">
              <v-icon :name="`update-${key}`"/>
            </div>

            <div :key="`${v.id}-${key}-content`" class="item-content border-bottom">
              <div class="record-list-item flex-justify-between">
                <div class="record-list-title">
                  修改{{ updateType.name }}
                </div>
                <div class="time accent-color">{{ v.add_time | timeToYmdHi }}</div>
              </div>

              <div class="record-list-item">

                <template v-if="v.old_student_name !== v.student_name">
                  姓名：「<span class="primary-color">{{v.old_student_name}}</span>」改为「<span class="success-color">{{v.student_name}}</span>」；
                </template>

                <template v-if="v.old_nickname !== v.nickname">
                  昵称：「<span class="primary-color">{{v.old_nickname}}</span>」改为「<span class="success-color">{{v.nickname}}</span>」；
                </template>

                <template v-if="v.old_avatar !== v.avatar">
                  头像：「<a v-if="v.old_avatar" class="primary-color" :href="v.old_avatar" target="_blank">{{ v.old_avatar }}</a><span v-else class="info-color">未上传</span>」改为「<a class="success-color" :href="v.avatar" target="_blank">{{ v.avatar }}</a>」；
                </template>

                <template v-if="v.old_selfie !== v.selfie">
                  真人自拍：「<a v-if="v.old_selfie" class="primary-color" :href="v.old_selfie" target="_blank">{{ v.old_selfie }}</a><span v-else class="info-color">未上传</span>」改为「<a class="success-color" :href="v.selfie" target="_blank">{{ v.selfie }}</a>」；
                </template>

                <template v-if="v.old_card_number !== v.card_number && (v.old_card_number || v.card_number)">
                  会员号：「<span v-if="v.old_card_number" class="primary-color">{{v.old_card_number}}</span><span v-else class="info-color">未填写</span>」改为「<span class="success-color">{{v.card_number}}</span>」；
                </template>

                <template v-if="v.old_phone !== v.phone">
                  手机号：「<span class="primary-color">{{v.old_phone}}</span>」改为「<span class="success-color">{{v.phone}}</span>」；
                </template>

                <template v-if="v.old_used_card_id !== v.used_card_id">
                  默认支付课卡：「<router-link v-if="v.old_used_card_id" :to="RouteConfig.cardDetail.to(v.old_used_card_id)" class="primary-color">{{ v.old_card_name }}</router-link><span v-else class="info-color">无</span> 」改为「<router-link :to="RouteConfig.cardDetail.to(v.used_card_id)" class="success-color">{{ v.card_name }}</router-link>」
                </template>
              </div>

              <div class="store-name accent-color">
                操作者：
                <span v-if="v.administrator_id">{{ v.administrator_nickname ? v.administrator_nickname : '未知管理员' }}</span>
                <span v-else>学员本人</span>
              </div>
            </div>
          </template>

        </template>
      </div>

      <div class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-tip-box">暂无个人资料修改记录</div>
  </div>
</template>

<script>
import scrollTo from "@/utils/scroll-to";
import { getStudentUpdateRecordsByStudentId } from "@/api/student-update-record";
import { studentUpdateTypes } from "@/enums/studentUpdateTypes";
import RouteConfig from "@/router/config";

export default {
  props: {
    studentId: Number,
  },
  data: () => ({
    RouteConfig,
    studentUpdateTypes,
    list: [],
    count: 0,
    page: 1,
    size: 8,
    pageSizes: [10, 20, 30],
  }),
  methods: {
    async getList() {
      const { isError, data } = await getStudentUpdateRecordsByStudentId({
        student_id: this.studentId,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
    },
    handlePageChange() {
      this.getList();
      scrollTo(0, 350);
    },
  },
  beforeMount() {
    this.getList();
  },
};
</script>

<style src="@/components/student-detail-record.css" scoped/>
